// Lib
import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useStyles } from './DetailsButtonStyles';

const DetailsButton = ({ to, padding, ...props }) => {
  const { classes } = useStyles({ padding });

  return (
    <Button
      className={classes.button}
      component={Link}
      to={to}
      endIcon={<ChevronRightIcon />}
      {...props}>
      Details
    </Button>
  );
};

export default DetailsButton;
